module.exports = __webpack_public_path__ + "img/adult-merry-jane-whiskey_2.950dea8b.jpg";